module.exports = __webpack_public_path__ + "img/whatInReportImage2.94bb7b5a.png";